import React from "react";
import { motion, Variants } from "framer-motion";
import haystack from "../../images/hayflyer.jpeg";
import { Link } from "react-router-dom";

// Animation factory
const fadeUp = (delay: number = 0): Variants => ({
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { delay, duration: 0.8, ease: "easeInOut" },
    },
});

const Haystack = () => {
    return (
        <div className="flex justify-center items-center flex-col gap-y-6 min-h-[100vh] xl:px-48 md:px-24 sm:px-16 px-8 py-28" id="haystack">
            {/* Image */}
            <motion.div
                variants={fadeUp(0.2)}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <img src={haystack} alt="Haystack Conference Flyer" className="w-[600px]" />
            </motion.div>

            {/* Paragraph */}
            <motion.p
                className="font-montserrat leading-[40px] md:text-center text-justify lg:text-base text-sm"
                variants={fadeUp(0.4)}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                The <b>Haystack Conference</b> is our own haystack, where prayers are
                made for the nations and the passion for the Gospel will be poured into
                many hearts again. Each year, we build another haystack monument that
                will commemorate the birth of greater moves of God across the world as
                we usher in mighty harvests across the globe through prayers and as more
                hearts are set on fire.
            </motion.p>

            {/* Button */}
            <motion.div
                className="mt-16"
                variants={fadeUp(0.6)}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <Link
                    to="/register"
                    className="font-montserrat border-2 text-grayX border-grayX rounded-md font-semibold py-2 px-10 lg:text-base text-sm tracking-[2px] hover:bg-deepGreen hover:text-white transition-colors"
                >
                    REGISTER
                </Link>
            </motion.div>
        </div>
    );
};

export default Haystack;
